import React, { lazy, Suspense } from 'react';

const LazyReduxSample = lazy(() => import('./ReduxSample'));

const ReduxSample = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyReduxSample {...props} />
  </Suspense>
);

export default ReduxSample;
